module.exports = __webpack_public_path__ + "img/connection-right-2.5dab8eda.png";